// extracted by mini-css-extract-plugin
module.exports = {"heading":"DataDeletionInstruction_heading__2Uv61","content":"DataDeletionInstruction_content__204gr"};